import * as React from "react"
import { Paper, Card } from "components"
import { Col, Row } from "reactstrap"
import { Link } from "react-router-dom"
import bitdefenderOff from "media/images/bitdefender-off.jpg"
import blogKasperksy from "media/images/blog-kaspersky.jpg"
import blogPadvish from "media/images/blog-padvish.jpg"
import { useInView } from "react-intersection-observer"

interface BlogTemplate {
	isMobile: boolean
}

const BlogTemplate: React.FC<BlogTemplate> = ({ children, isMobile }) => {
	const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "100px" })
	if (isMobile) return <>{children}</>

	return (
		<Row>
			<Col lg={3} className="d-none d-lg-inline">
				<div className="sticky-top pt-1">
					<Card title="آخرین پست ما در اینستاگرام" className="mb-2">
						a
					</Card>
					<Card title="راهنمای خرید آنتی ویروس">a</Card>
				</div>
			</Col>
			<Col>{children}</Col>
			<Col lg={2} className="d-none d-lg-inline">
				<div className="sticky-top pt-1">
					<Paper className="mb-2">
						<Link to="/shop/bitdefender">
							<img
								alt="تخفیف ۵۰٪ محصولات بیت دینفدر"
								src={bitdefenderOff}
								className="img-fluid"
							/>
						</Link>
					</Paper>
					<Paper className="mb-2">
						<img
							alt="خرید محصولات سازمانی کسپرسکی"
							src={blogKasperksy}
							className="img-fluid"
						/>
					</Paper>
					<Paper className="mb-2">
						<Link to="/product/NAP-10016">
							<img
								ref={ref}
								alt="ضدباجگیر پادویش "
								src={inView ? blogPadvish : ""}
								className="img-fluid"
							/>
						</Link>
					</Paper>
				</div>
			</Col>
		</Row>
	)
}

export default BlogTemplate
